module.exports = __webpack_public_path__ + "img/Banos.45f3f46f.png";